import React from 'react'
import { Alert, FormControl, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material'
import { WIZARD_SESSION_TYPES, getTypeMeta } from '../sessionTypeCatalog'

// Step 2. Picking the type is what decides the remaining steps, and it is also the last
// point at which the session row does not yet exist - the backend dereferences
// session.type unguarded on create (vizpi_backend/services/sessionService.js:37), so the
// row cannot be created before this step is answered.
//
// What a student gets for the chosen language shows in the wizard's live preview column.
const TypeStep = ({ type, setType, locked }) => {
  const groups = ['Code', 'Web', 'Other']
  const meta = getTypeMeta(type)

  return (
    <>
      <div className="cq-card__head">
        <div>
          <h2>Language</h2>
          <p>Decides the editor students get and how their work is graded. The preview updates as you choose.</p>
        </div>
      </div>

      {locked && (
        <Alert severity="info" sx={{ mb: 2 }}>
          The session has already been created, so its language is fixed here.
        </Alert>
      )}

      <FormControl disabled={locked} sx={{ width: '100%' }}>
        <RadioGroup value={type} onChange={(e) => setType(e.target.value)}>
          {groups.map((group) => (
            <div key={group} style={{ marginBottom: '14px' }}>
              <Typography variant="overline" sx={{ color: '#6b7280', letterSpacing: '0.08em' }}>
                {group}
              </Typography>
              {WIZARD_SESSION_TYPES.filter((t) => t.group === group && !t.hidden).map((t) => (
                <FormControlLabel
                  key={t.value}
                  value={t.value}
                  control={<Radio size="small" />}
                  sx={{ display: 'flex', alignItems: 'flex-start', mt: 0.5 }}
                  label={
                    <span>
                      <span style={{ fontWeight: 500 }}>{t.label}</span>
                      {t.blurb && (
                        <span style={{ display: 'block', fontSize: '12px', color: '#6b7280' }}>
                          {t.blurb}
                        </span>
                      )}
                    </span>
                  }
                />
              ))}
            </div>
          ))}
        </RadioGroup>
      </FormControl>

      {meta?.kind === 'sql' && (
        <Alert severity="info">
          SQL exercises do not use generated test-case rows. You will write the schema and
          generate a reference query in a later step instead.
        </Alert>
      )}
    </>
  )
}

export default TypeStep
